import PropTypes from "prop-types";
import { Pill } from "components/common";
import PRODUCT_CONFIG from "./config";

const ProductPill = ({ product }) => {
  const { pillColor, fontColor, label } =
    PRODUCT_CONFIG[product] || PRODUCT_CONFIG.other;

  return Pill({ pillColor, fontColor, label: label || product });
};

ProductPill.propTypes = {
  product: PropTypes.string.isRequired,
};

export default ProductPill;
